import { Component, OnInit } from '@angular/core';
import { Globals } from '../_models/globals';

@Component({
  selector: 'app-login-container',
  templateUrl: './login-container.component.html',
  styleUrls: ['./login-container.component.css']
})
export class LoginContainerComponent implements OnInit {

  constructor(public g: Globals) {
    document.getElementById('mainBody').className = 'new-login';
  }

  ngOnInit() {
  }
}
